import { Flex, type FlexProps, Indicator, Text } from '@mantine/core'

import { type IBookingStatus } from '@flecto-io/core/src/interfaces'
import { useTranslation } from '@flecto/translations'

import {
  getBadgePaymentInfo,
  getBadgeStatusInfo,
} from '../../../bookings/@legacy/Bookings/utils/BadgeVariant'
import type { ScheduleBooking } from '../../types/ScheduleBooking'

export type CellStatusesProps = FlexProps & {
  booking: ScheduleBooking
}

export function CellStatuses({ booking, ...props }: CellStatusesProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'schedule' })
  const statusBadgeInfo = getBadgeStatusInfo(booking.status as IBookingStatus)
  const paymentBadgeInfo = getBadgePaymentInfo(
    booking?.payment_rental_status ?? ''
  )

  const statuses = [statusBadgeInfo, paymentBadgeInfo]

  return (
    <Flex {...props} direction='column' gap='sm'>
      {statuses.map(({ color, translationKey }, key) => (
        <Text
          key={`booking-card-status-${String(key)}`}
          size='sm'
          c={color}
          mt={-2}
          lh={1.5}
        >
          <Indicator color={color} size={5} offset={-8} position='middle-start'>
            {t(translationKey)}
          </Indicator>
        </Text>
      ))}
    </Flex>
  )
}
